module.exports = __webpack_public_path__ + "img/logo-google-store.24430e8a.png";